module.exports = __webpack_public_path__ + "static/media/PushtimargImage17.af475195.jpg";